import { type IMapLayer, MapLayerType } from '../../layers/MapLayer.ts';
import { MapWidgetLogic } from '../../MapWidgetLogic.ts';

/**
 * Code di default del layer catastale (preset). Non è riservato: se in
 * conflitto con un altro layer viene deduplicato come gli altri code.
 */
export const CADASTRAL_LAYER_CODE = 'cadastral';

const CADASTRAL_ATTRIBUTES = ['SEZIONE', 'NUMERO', 'COMUNE', 'FOGLIO'];

const CADASTRAL_ALIASES: Record<string, string> = {
  COMUNE: 'Comune catastale',
  FOGLIO: 'Foglio catastale',
  SEZIONE: 'Sezione catastale',
  NUMERO: 'Particella catastale',
};

const CADASTRAL_STYLE = {
  fillColor: '#a51309',
  strokeColor: '#008577',
  strokeWidth: 1,
  opacity: 0.85,
};

/**
 * Crea un layer ArcGIS vettoriale pre-compilato con configurazione catastale.
 * L'URL viene letto dalla variabile d'ambiente `CADASTRAL_LAYER_URL` tramite `MapWidgetLogic`.
 * Utilizzato dal pulsante "Aggiungi Layer Particelle Catastali" nel configuratore.
 */
export function createCadastralPresetLayer(): IMapLayer {
  return {
    type: MapLayerType.ArcGISRestVector,
    code: CADASTRAL_LAYER_CODE,
    name: 'Particelle catastali',
    url: MapWidgetLogic.getCadastralLayerUrl(),
    style: CADASTRAL_STYLE,
    intersection: {
      enabled: true,
      title: 'Informazioni Catastali',
      attributes: CADASTRAL_ATTRIBUTES,
      aliases: CADASTRAL_ALIASES,
      areaTolerance: 0.05,
      cadastralPreset: true,
    },
  };
}
